import { AddressLabel, AddressLabelLabels } from '@navio/nsdk';
import { entriesToOptions, getLabel, getLabelMapFromEntries } from 'noddi-util';
import { z } from 'zod';

export const ADDRESS_LABEL_OPTIONS = entriesToOptions(AddressLabel, AddressLabelLabels);

const ADDRESS_LABEL_TEXT = getLabelMapFromEntries(AddressLabel, AddressLabelLabels);

export const getAddressLabelText = (label: AddressLabel): string => getLabel(label, ADDRESS_LABEL_TEXT);

const ADDRESS_LABEL_VALUES = Object.values(AddressLabel) as [AddressLabel, ...AddressLabel[]];

export const addressLabelFormSchema = z
  .object({
    label: z.enum(ADDRESS_LABEL_VALUES),
    customLabel: z.string()
  })
  .superRefine((value, context) => {
    if (value.label === AddressLabel.CUSTOM && !value.customLabel.trim()) {
      context.addIssue({ code: 'custom', message: 'Enter a label', path: ['customLabel'] });
    }
  });

export type AddressLabelFormValues = z.input<typeof addressLabelFormSchema>;
